import { createSvgIcon } from '@mui/material';

export const SettingsIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
    <path
      fill="currentColor"
      d="M6.59 3.992c.61.372 1.405.043 1.573-.65l.069-.285a1.82 1.82 0 0 1 3.536 0l.07.284a1.054 1.054 0 0 0 1.572.651l.25-.152a1.82 1.82 0 0 1 2.5 2.5l-.152.25a1.054 1.054 0 0 0 .65 1.573l.285.069a1.82 1.82 0 0 1 0 3.536l-.284.07a1.054 1.054 0 0 0-.651 1.571l.152.25a1.82 1.82 0 0 1-2.5 2.5l-.25-.151a1.054 1.054 0 0 0-1.573.65l-.069.285a1.82 1.82 0 0 1-3.536 0l-.07-.284a1.054 1.054 0 0 0-1.571-.651l-.25.152a1.82 1.82 0 0 1-2.5-2.5l.152-.25a1.054 1.054 0 0 0-.652-1.573l-.284-.069a1.82 1.82 0 0 1 0-3.536l.284-.07a1.054 1.054 0 0 0 .652-1.571l-.153-.25a1.82 1.82 0 0 1 2.5-2.5l.25.151ZM10 13.788a3.788 3.788 0 1 0 0-7.576 3.788 3.788 0 0 0 0 7.576Z"
    />
  </svg>,
  'SettingsIcon',
);
